import type { UserCreditsSummary } from '@/credits/domain/balance';

export type CreditBalanceResult = UserCreditsSummary & {
  balance: number;
};

export type CreditBalanceApiResponse = {
  success: boolean;
  summary?: UserCreditsSummary;
  error?: string;
};

export async function fetchCreditBalanceFromApi() {
  const response = await fetch('/api/credits/balance', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
    cache: 'no-store',
    credentials: 'include',
  });

  const result = (await response.json()) as CreditBalanceApiResponse;
  if (!response.ok || !result.success) {
    throw new Error(result.error || 'Failed to fetch credit balance');
  }

  const summary = result.summary;
  if (!summary) {
    throw new Error('Credit balance response is missing summary');
  }

  return {
    ...summary,
    balance: summary.availableCredits,
  } satisfies CreditBalanceResult;
}
